module.exports = __webpack_public_path__ + "img/ai.94d540d1.png";